import React from 'react'
import { connect } from 'react-redux'
import { Grid, Segment } from 'semantic-ui-react'
import { FakeInput, GridContainer } from 'shared/StyledComponents'
import { translate } from 'loankeeper-common/helpers'
import { LKHeader } from 'loankeeper-common/components'
import LKButton from 'shared/LKButton'
import withLivedata from 'shared/containers/withLivedata'
import { withUserConfig } from 'shared'
import withLookups, { LookupType } from 'shared/containers/withLookups'
import { Loan } from 'WebAPI'
import { reactForm, FormField } from 'shared/reactForm'

import LKModal, { LKModalTrigger, LKModalContainer, actions as LKModalActions } from 'shared/LKModal'
import { loadProductDetailsIfNeeded } from '../../store/product'
import ActiveNotesModal, { openActiveNotesModal } from '../LoanDetails/ActiveNotesModal'
import { loadClientDetails } from '../../store/client'

const trans = (key) => translate(`frm_loan_disburse-${key}`)
const transLKM = (name) => translate(`LKMESSAGE-${name}`)

const MODAL_NAME = 'LoanDisburseNoAcc'

const Hr = () => <hr />

const Hr1 = () => <hr style={{ marginTop: 0, marginBottom: 5 }} />

const Hr2 = () => <hr style={{ marginTop: 5, marginBottom: 0 }} />

const Hr0 = () => <hr style={{ marginTop: 0, marginBottom: 0 }} />

const gridStyle = { marginRight: 5 }

export const open = (args) => LKModalActions.open({ name: MODAL_NAME, ...args })

@LKModalContainer(MODAL_NAME)
@withLookups({ type: LookupType.Account, query: 'AMEX_Account' })
@withUserConfig('LocalCCY')
@withLivedata(['OpenDayStatus.Open_Day_Str as OpenDayStr', 'CCYOfficalRates'])
@connect(undefined, {
  openError: (message) => LKModalActions.openError(message),

  openWatchConfirm: () =>
    LKModalActions.openConfirmation('LoanDisburseNoAccWatchConfirm', {
      message: `${transLKM('ERR_CLIENT_WATCHED')}, ${transLKM('CONFIRM_VALIDATION_WARNING_OVERRIDE')}`,
    }),

  openActiveNotesModal,
  loadClientDetails,
  loadProductDetailsIfNeeded,
})
@reactForm({
  initialValues: (props) => ({
    ProcedureFee: 0,
    ProcedureFeeLoc: 0,
    PayerDetails: props.params.FullName,
    CashAuth: true,
  }),
})
class LoanDisburseNoAcc extends React.Component {
  constructor(props) {
    super(props)

    this.AmexAccounts = props.AMEX_Account.map((a) => ({ value: a.ID, text: a.Description }))

    this.fetchData()
  }

  state = { fetching: true }

  fetchData = async () => {
    try {
      const { ID, hash, clientID, clientHash } = this.props.params

      const disbvalPromise = Loan.loanOper({
        LoanID: ID,
        HashSum_LoanID_: hash,
        page: 'disbursevalidate',
        Amount: 0,
        OperDate: this.props.OpenDayStr,
      })

      this.loan = (
        await Loan.details({
          ID,
          hash,
          page: 'base',
        })
      ).Data

      if (this.loan.ClientNoteCount > 0 || this.loan.LoanNoteCount > 0) {
        this.loadActiveNotes()
        this.props.openActiveNotesModal()
      }

      this.prod = await this.props.loadProductDetailsIfNeeded({
        productId: this.loan.ProductID,
        productHash: this.loan.HashSum_ProductID_,
      })

      this.amount = (await disbvalPromise).Data

      const clientDetailsResult = await this.props.loadClientDetails({
        clientId: clientID,
        clientHash: clientHash,
      })

      if (loadClientDetails.fulfilled.match(clientDetailsResult)) {
        this.client = clientDetailsResult.payload
      }

      const rate = this.props.CCYOfficalRates.find((r) => r.CCY === this.loan.ISO)

      this.props.form.initialize({
        Amount: this.amount,
        AmountLoc: rate && rate.OffRate ? Math.round(this.amount * rate.OffRate * 100) / 100 : this.amount,
        AMEX_AccountID: this.AmexAccounts[0].value,
        PayerDetails: this.loan.FullName,
      })

      this.props.form.setValidateFn(this.validate)
    } catch (e) {
      this.props.openError(e.Error.Message || e.Error.Text || transLKM('HINT_ERR_TITLE'))
      this.props.closeModal()
    } finally {
      this.setState({ fetching: false })
    }
  }

  validate = (values) => {
    const min = transLKM('HINT_PROD_MIN')
    const max = transLKM('HINT_PROD_MAX')

    const ccy = this.prod.CCYCheck === 1 ? this.prod.CCY.find((c) => c.CCY === this.loan.ISO) : undefined

    const amount = parseFloat(values.Amount)

    const amountMin = ccy ? ccy.AmountMin : 0
    const amountMax = ccy ? Math.min(this.amount, ccy.AmountMax) : this.amount

    return {
      Amount:
        !isNaN(values.Amount) && amount >= amountMin && amount <= amountMax
          ? undefined
          : `${min} ${amountMin} ${max} ${amountMax}`,
    }
  }

  handleSubmit = () => {
    if (this.client.Watched === 1) this.props.openWatchConfirm()
    else this.props.form.handleSubmit(this.submit)
  }

  handleWatchConfirm = () => {
    this.props.form.handleSubmit(this.submit)
  }

  handleWatchReject = () => {
    this.props.closeModal()
  }

  submit = async ({ Amount, ProcedureFee, AMEX_AccountID, PayerDetails, Comment, CashAuth }) => {
    const { closeModal, onSuccess, openError, OpenDayStr } = this.props

    try {
      await Loan.loanOper({
        page: 'disbursenoacc',
        LoanID: this.props.params.ID,
        HashSum_LoanID_: this.props.params.hash,
        OperDate: OpenDayStr,
        Amount,
        ProcedureFee,
        AMEX_AccountID,
        PayerDetails,
        Comment,
        CashAuth: +CashAuth,
      })

      closeModal()

      if (onSuccess) onSuccess()
    } catch (e) {
      openError(e.Error.Message || e.Error.Text || transLKM('HINT_ERR_TITLE'))
    }
  }

  handlePayerDetails = () => {
    const { form } = this.props

    form.changeValues({ PayerDetails: form.values.PayerDetails ? '' : this.loan.FullName })
  }

  handleAmountChange = (event, data, { value }) => {
    const { form } = this.props

    const rate = this.props.CCYOfficalRates.find((r) => r.CCY === this.loan.ISO)

    form.changeValues({
      Amount: value,
      AmountLoc: rate && rate.OffRate ? Math.round(value * rate.OffRate * 100) / 100 : value,
    })
  }

  handleAmountLocChange = (event, data, { value }) => {
    const { form } = this.props

    const rate = this.props.CCYOfficalRates.find((r) => r.CCY === this.loan.ISO)

    form.changeValues({
      AmountLoc: value,
      Amount: rate && rate.OffRate ? Math.round((value / rate.OffRate) * 100) / 100 : value,
    })
  }

  handleProcedureFeeChange = (event, data, { value }) => {
    const { form } = this.props

    const rate = this.props.CCYOfficalRates.find((r) => r.CCY === this.loan.ISO)

    form.changeValues({
      ProcedureFee: value,
      ProcedureFeeLoc: rate && rate.OffRate ? Math.round(value * rate.OffRate * 100) / 100 : value,
    })
  }

  handleProcedureFeeLocChange = (event, data, { value }) => {
    const { form } = this.props

    const rate = this.props.CCYOfficalRates.find((r) => r.CCY === this.loan.ISO)

    form.changeValues({
      ProcedureFeeLoc: value,
      ProcedureFee: rate && rate.OffRate ? Math.round((value / rate.OffRate) * 100) / 100 : value,
    })
  }

  render() {
    const { modalInstanceName, form, params } = this.props

    const { submitting } = form

    const { fetching } = this.state

    return (
      <>
        <LKModal.Confirmation
          name="LoanDisburseNoAccWatchConfirm"
          onConfirm={this.handleWatchConfirm}
          onClose={this.handleWatchReject}
        />

        <ActiveNotesModal data={this.props.params} />

        <LKModal
          icon="disburse"
          name={modalInstanceName}
          heading={`${trans('frm_loan_disburse')} - ${
            (params && params.FullName) || (this.loan && this.loan.FullName)
          }`}
          loading={fetching}
          size="medium"
          footer={
            <LKModal.Footer>
              <LKButton
                alias="ok"
                className="okay-button"
                onClick={this.handleSubmit}
                loading={submitting}
                disabled={submitting}
              >
                {trans('cmd_finish')}
              </LKButton>

              <LKModal.CancelButton disabled={submitting} text={trans('cmd_cancel')} />
            </LKModal.Footer>
          }
        >
          <div className="u-flexCenter u-padding-10" style={{ backgroundColor: '#ffffcc' }}>
            <LKHeader>
              {trans('lbl_resbalance_t')} - {this.loan.ResourceTitle}
            </LKHeader>
          </div>

          <Hr1 />

          <div className="u-flexCenter u-padding-5">
            <div className="u-paddingRight-10">{trans('lbl_date')}</div>
            <div style={{ width: 100 }}>
              <FakeInput className="u-fluid">
                <Segment className="u-flexCenter" style={{ padding: 0, paddingTop: 3 }}>
                  <LKHeader size="small">{this.props.OpenDayStr}</LKHeader>
                </Segment>
              </FakeInput>
            </div>
          </div>

          <Hr />

          <GridContainer style={gridStyle}>
            <Grid>
              <Grid.Row>
                <Grid.Column width={6} className="u-flex u-alignCenter u-pullRight">
                  {trans('lbl_disburse')}
                </Grid.Column>

                <Grid.Column width={3}>
                  <FormField type="number" name="Amount" form={form} autoWidth onChange={this.handleAmountChange} />
                </Grid.Column>

                <Grid.Column width={2} className="u-flex u-alignCenter">
                  {this.loan.ISO}
                </Grid.Column>

                <Grid.Column width={3}>
                  <FormField
                    type="number"
                    name="AmountLoc"
                    form={form}
                    autoWidth
                    onChange={this.handleAmountLocChange}
                  />
                </Grid.Column>

                <Grid.Column width={2} className="u-flex u-alignCenter">
                  {this.props.LocalCCY}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>

          <Hr />

          <GridContainer style={gridStyle}>
            <Grid>
              <Grid.Row>
                <Grid.Column width={6} className="u-flex u-alignCenter u-pullRight">
                  {trans('lbl_proc_fee_t')}
                </Grid.Column>

                <Grid.Column width={3}>
                  <FormField
                    type="number"
                    name="ProcedureFee"
                    form={form}
                    autoWidth
                    onChange={this.handleProcedureFeeChange}
                  />
                </Grid.Column>

                <Grid.Column width={2} className="u-flex u-alignCenter">
                  {this.loan.ISO}
                </Grid.Column>

                <Grid.Column width={3}>
                  <FormField
                    type="number"
                    name="ProcedureFeeLoc"
                    form={form}
                    autoWidth
                    onChange={this.handleProcedureFeeLocChange}
                  />
                </Grid.Column>

                <Grid.Column width={2} className="u-flex u-alignCenter">
                  {this.props.LocalCCY}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>

          <Hr />

          <GridContainer style={gridStyle}>
            <Grid>
              <Grid.Row>
                <Grid.Column width={6} className="u-flex u-alignCenter u-pullRight">
                  {trans('lbl_payer')}
                </Grid.Column>

                <Grid.Column width={5}>
                  <div className="u-flex">
                    <div className="u-fluid u-marginRight-5">
                      <FormField type="text" name="PayerDetails" form={form} autoWidth />
                    </div>

                    <LKButton alias="users" onClick={this.handlePayerDetails} />
                  </div>
                </Grid.Column>

                <Grid.Column width={5}>
                  <FormField type="select" name="AMEX_AccountID" form={form} options={this.AmexAccounts} autoWidth />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>

          <Hr />

          <GridContainer style={gridStyle}>
            <Grid>
              <Grid.Row>
                <Grid.Column width={6} className="u-flex u-alignCenter u-pullRight">
                  {trans('lbl_comment')}
                </Grid.Column>

                <Grid.Column width={5}>
                  <FormField type="text" name="Comment" form={form} autoWidth />
                </Grid.Column>

                <Grid.Column width={5} className="u-flex u-alignCenter">
                  <FormField type="checkbox" label={trans('chk_auth')} name="CashAuth" form={form} autoWidth />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>

          <Hr2 />

          <div className="u-flexCenter u-padding-10" style={{ backgroundColor: '#00b900' }}>
            <LKHeader style={{ color: 'white' }}>{trans('lbl_disburse_ok')}</LKHeader>
          </div>

          <Hr0 />
        </LKModal>
      </>
    )
  }
}

export const LoanDisburseNoAccTrigger = ({ children, params }) => (
  <LKModalTrigger name="LoanDisburseNoAcc" alias="disburse" params={params} permission="LOAN_DISBURSE">
    {children}
  </LKModalTrigger>
)

export default LoanDisburseNoAcc
